module.exports = __webpack_public_path__ + "static/screen-landrover.e4ee9c72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/screen-landrover.jpg
// module id = 416
// module chunks = 114276838955818